/** ===========
 * 全局自定义过滤器
 * ============
 */
// import utils from "./utils";
import moment from '@/plugins/moment';

export default {
  /**
   * 处理静态资源链接，添加七牛地址前缀
   */
  // assetsUrlFil: url => utils.handleAssetsUrl(url),
  /**
   * 处理时间戳
   * 返回格式：yyyy-mm-dd hh:mm
   */
  tsFil(ts) {
    if (!ts) return;
    //分钟必须是两位数
    function checkTime(t) {
      if (t < 10) {
        t = '0' + t;
        return t;
      } else {
        return t;
      }
    }
    //浏览器兼容，不能用toLocaleString()
    ts = new Date(parseInt(ts * 1000));

    let y, mon, day, hou, min;
    y = ts.getFullYear();
    mon = ts.getMonth() + 1;
    day = ts.getDate();
    hou = ts.getHours();
    min = checkTime(ts.getMinutes());

    let time = `${y}-${mon}-${day} ${hou}:${min}`;
    return time;
  },
  /**
   * 处理手机显示
   * 返回格式132****1632
   */
  formatPhone(v) {
    var reg = /^(\d{3})\d*(\d{4})$/;
    v = v.toString();
    return v && v.replace(reg, '$1****$2');
  },
  /**
   * 可根据性处理用户头像兼容问题
   * 头像必须都存储在七牛云上的
   * @param {用户信息} userInfo
   */
  // avantaFil(userInfo) {
  //     // 存在userInfo===null的情况
  //     let avantaUrl;
  //     if (typeof userInfo === "string") {
  //         avantaUrl = userInfo || "web/defaultAvanta.jpg";
  //     } else {
  //         avantaUrl = userInfo ?
  //             (userInfo.headImgUrl ? `${userInfo.headImgUrl}` : (userInfo.sex ? "web/defaultAvanta.jpg" : "web/defaultAvanta.jpg")) :
  //             "web/defaultAvanta.jpg";
  //     }
  //     return utils.handleAssetsUrl(avantaUrl);
  // },
  /**
   * 格式化浏览量，超过5位数变为万的单位
   */
  browseFil(num) {
    let _num = (num / 10000).toFixed(1);
    return _num >= 1 ? `${_num}万` : num;
  },
  /**
   * momentjs过滤器
   * dateStr: 时间。  patter：格式
   * 用法：
   * {{date | moment}}
   * {{date | moment(pattern)}}
   */
  moment(dateStr, pattern = 'YYYY-MM-DD HH:mm') {
    /**
     * 处理10位和13位的时间戳，同时时间戳转换为momentjs接受的number类型
     */
    const reg = /^[0-9]+$/;
    if (reg.test(dateStr)) {
      dateStr = dateStr.toString();
      dateStr = dateStr.length === 10 ? Number(dateStr * 1000) : dateStr.length === 13 ? Number(dateStr) : dateStr;
    }
    return moment(dateStr).format(pattern);
  },
  /**
   * formatTime过滤器
   * duration 时长
   * 用法：
   * {{time | formatTime}}
   */
  formatTime(duration) {
    if (duration <= 0) return '00:00';
    if (!duration) return '--:--';
    let min = ~~(duration / 60);
    min = min.toString().padStart(2, '0');
    let sec = Math.floor(duration % 60);
    sec = sec.toString().padStart(2, '0');
    return min + ':' + sec;
  }
};
